export default {"src":"/_next/static/media/404.c9bb994f.svg","height":368,"width":503,"blurWidth":0,"blurHeight":0};